module.exports = __webpack_public_path__ + "static/media/boatyard_marker_dark_blue.fc6fdb5c.svg";